module.exports = __webpack_public_path__ + "static/img/hm_loop_card_01.5842849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthMonitoring/hm_loop_card_01.png
// module id = GOtE
// module chunks = 1